import angular from 'angular';

module.exports = angular.module('common.directives.inject-to-transclusion-scope', [
])
.directive('injectToTransclusionScope', function() {
  return {
    restrict: 'A',
    scope: {
      injectToTransclusionScope: '<',
      injectAs: '@?',
    },
    link(scope, iElement, iAttrs, $ctrl, transcludeFn) {
      var variableName = scope.injectAs || 'option';
      transcludeFn((clone, transclusionScope) => {
        scope.$watch('injectToTransclusionScope', value => {
          transclusionScope[variableName] = value;
        });
        iElement.empty();
        iElement.append(clone);
        iElement.on('$destroy', () => transclusionScope.$destroy());
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/inject-to-transclusion-scope.js
 **/